'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.formatLocation = exports.getPlaceFromBrowser = exports.createGeolocation = exports.getPlaceFromUrl = exports.decodePlace = exports.encodePlace = undefined;

var _queryString = require('query-string');

var qs = _interopRequireWildcard(_queryString);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var encodePlace = exports.encodePlace = function encodePlace(place) {
    return window.btoa(JSON.stringify(place));
};
var decodePlace = exports.decodePlace = function decodePlace(place) {
    if (!place) {
        return undefined;
    }
    try {
        return JSON.parse(window.atob(place));
    } catch (err) {
        return undefined;
    }
};
var getPlaceFromUrl = exports.getPlaceFromUrl = function getPlaceFromUrl(search) {
    return decodePlace(qs.parse(search).place);
};
var createGeolocation = exports.createGeolocation = function createGeolocation(latitude, longitude) {
    return { type: 'geolocation', coordinates: { longitude: longitude, latitude: latitude } };
};
var getPlaceFromBrowser = exports.getPlaceFromBrowser = function getPlaceFromBrowser(nav) {
    var useGeoIp = { type: 'geoip', geoip: true };
    if ('geolocation' in nav) {
        return new Promise(function (resolve, reject) {
            var success = function success(_a) {
                var _b = _a.coords,
                    longitude = _b.longitude,
                    latitude = _b.latitude;
                return resolve(createGeolocation(longitude, latitude));
            };
            var failure = function failure() {
                return resolve(useGeoIp);
            };
            nav.geolocation.getCurrentPosition(success, failure);
        });
    }
    return Promise.resolve(useGeoIp);
};
var formatLocation = exports.formatLocation = function formatLocation(location) {
    if (!location) {
        return '';
    }
    var locationCity = location.city ? " , " + location.city : '';
    return "" + location.country + locationCity;
};
//# sourceMappingURL=location.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/web-ui/dist/order/views/pay-page/helpers/location.js
// module id = 1977
// module chunks = 0